import { LayerChange } from './layerTypes'

/**
 * Sorts the changed layers into the groups the list shows them in.
 *
 * Grouping rather than comparing, which is why it is here and not in the
 * renderer: the comparison reports a flat list of what differs, and how that
 * list is arranged for a reader is the panel's business.
 */

/** The changed layers of each entity, by the entity's uuid. */
export function groupLayerChangesByEntity(
  changes: readonly LayerChange[]
): Map<string, LayerChange[]> {
  const byEntity = new Map<string, LayerChange[]>()

  for (const change of changes) {
    if (!change.entityUUID) continue

    const existing = byEntity.get(change.entityUUID)
    if (existing) existing.push(change)
    else byEntity.set(change.entityUUID, [change])
  }

  return byEntity
}

/**
 * The changed layers that belong to no frame or Section.
 *
 * A page can carry layers directly, and they change like any other. Without a
 * group of their own they would be found by the comparison and then shown
 * nowhere, which reads as the page being unchanged.
 */
export function unattributedLayerChanges(
  changes: readonly LayerChange[]
): LayerChange[] {
  return changes.filter(change => !change.entityUUID)
}
